import { createFileRoute } from '@tanstack/react-router';
import { MyTruckPage } from '@/features/inventory/MyTruckPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/my-truck')({
  component: MyTruckPage,
});
